import React from 'react'
import List from '../../crud/list'
import menuItems from './menuItems'

const columns = [
  {
    title: 'Discount',
    prop: 'discount_id',
    references: 'admin/discounts',
    referenceProp: 'code'
  },
  {
    title: 'Discount Flat Amount',
    prop: 'discount_flat_amount',
    format: 'currency'
  },
  {
    title: 'Discount Percent Amount',
    prop: 'discount_percent_amount',
    format: 'percentage'
  },
  {
    title: 'Created',
    prop: 'created_at',
    format: 'dateWithTime'
  },
  {
    title: 'Updated At',
    prop: 'updated_at',
    format: 'dateWithTime'
  }
]

const defaults = {
  order: [{ column: 'id', direction: 'asc' }]
}

const OrderDiscounts = props => {
  const { orderId } = props.params

  return (
    <List
      title='Order Discounts'
      apiPath='admin/order_discounts'
      fixedFilters={{
        order_id: orderId
      }}
      columns={columns}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default OrderDiscounts
